import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DESCRIPTION_CONTROLS, EDIT_DESCRIPTION_CONTROLS } from '../config/description-form.config';
import { RiskFormula } from '../../../models/risk-formula';
import { FormControlModel } from '../../risk-distribution/config/risk-distribution-form-controls.config';
import { DescriptionFormDropdownList, getDescriptionFormDropdowns } from '../config/description-form-dropdowns.config';

@Component({
  selector: 'lib-formula-description',
  templateUrl: './formula-description.component.html',
  styleUrls: ['./formula-description.component.scss']
})
export class FormulaDescriptionComponent {
  selectedFormula!: RiskFormula;
  formulaEditForm!: FormGroup;
  descriptionControls = [];
  formulaEditFormDropdowns!: DescriptionFormDropdownList;

  constructor(
    public translateService: TranslateService,
    private fBuilder: FormBuilder
  ) { }

  displayForm(selectedFormula?: RiskFormula): void {
    this.selectedFormula = selectedFormula;
    this.formulaEditFormDropdowns = getDescriptionFormDropdowns(this);
    this.buildFormulaDescriptionForm();
  }

  buildFormulaDescriptionForm(): void {
    this.descriptionControls = (!this.selectedFormula
      ? DESCRIPTION_CONTROLS
      : [...DESCRIPTION_CONTROLS, ...EDIT_DESCRIPTION_CONTROLS])
      .sort((ctrl, ctrl2) => ctrl.position - ctrl2.position);

    this.formulaEditForm = this.fBuilder.group({});

    for (const ctrl of this.descriptionControls) {
      this.formulaEditForm.addControl(
        ctrl.key,
        this.fBuilder.control(
          !this.selectedFormula
            ? ctrl.value
            : this.selectedFormula[ctrl.key],
          this.setFormControlValidators(ctrl)
        )
      );
    };
  }

  setFormControlValidators(control: FormControlModel): ValidatorFn[] {
    const validators: ValidatorFn[] = [];

    if (control.required)  validators.push(Validators.required);
    if (control.maxLength) validators.push(Validators.maxLength(control.maxLength));
    if (control.minLength) validators.push(Validators.minLength(control.minLength));

    return validators;
  }

  formControl(key: string): FormControl {
    return this.formulaEditForm.get(key) as FormControl;
  }

  getFormValue(): any {
    return this.formulaEditForm.getRawValue();
  }

  markFormAsInvalid(): void {
    Object.values(this.formulaEditForm.controls).forEach(ctrl => {
      if (ctrl.invalid) {
        ctrl.markAsDirty();
        ctrl.markAsTouched();
      }
    });
  }

}
